import { faTrashCan } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Modal from 'react-bootstrap/Modal'
import React, { Fragment, useState, useRef } from 'react'
import 'primereact/resources/themes/lara-light-cyan/theme.css'
import { Toast } from 'primereact/toast'
import { Link, useNavigate } from 'react-router-dom'
import { API_URL } from '../../utils/Constants/URLS'
import { Card, CardBody, CardHeader } from 'reactstrap'

const EMPTY_ADDRESS = {
  addressNickName: '',
  addressLine1: '',
  addressLine2: '',
  state: '',
  country: 'India',
  pincode: '',
}

const EMPTY_CONTACT = { name: '', email: '', phone: '', designation: '' }

const AddVendor = () => {
  const toast = useRef(null)
  const token = localStorage.getItem('token')
  let countContactPerson = 0
  const navigate = useNavigate()

  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [showDeclineModal, setShowDeclineModal] = useState(false)

  const [vendorName, setVendorName] = useState('')
  const [vendorEmail, setVendorEmail] = useState('')
  const [vendorPhone, setVendorPhone] = useState('')
  const [gstin, setGstin] = useState('')

  // ── Address State ────────────────────────────────────────────────────────────
  const [addresses, setAddresses] = useState([{ ...EMPTY_ADDRESS }])

  const handleAddressInput = (e, index) => {
    const { name, value } = e.target
    setAddresses(prev => {
      const updated = [...prev]
      updated[index] = { ...updated[index], [name]: value }
      return updated
    })
  }

  const handleAddAddress = () => {
    setAddresses(prev => [...prev, { ...EMPTY_ADDRESS }])
  }

  const handleDeleteAddress = index => {
    setAddresses(prev => prev.filter((_, idx) => idx !== index))
  }

  // ── Contact Person State ─────────────────────────────────────────────────────
  const [contactPersons, setContactPersons] = useState([{ ...EMPTY_CONTACT }])

  const handleContactInput = (e, index) => {
    const { name, value } = e.target
    setContactPersons(prev => {
      const updated = [...prev]
      updated[index] = { ...updated[index], [name]: value }
      return updated
    })
  }

  const handleAddContactPerson = () => {
    setContactPersons([...contactPersons, { ...EMPTY_CONTACT }])
  }

  const handleDeleteContactPerson = index => {
    setContactPersons(contactPersons.filter((_, idx) => idx !== index))
  }

  // ── Modal ────────────────────────────────────────────────────────────────────
  const handleCloseModal = () => {
    if (showSuccessModal === true) {
      setShowSuccessModal(false)
      navigate('/purchase/view_vendors')
    }
    setShowDeclineModal(false)
  }

  // ── Submit ───────────────────────────────────────────────────────────────────
  const handleSubmit = async e => {
    e.preventDefault()

    const showError = detail =>
      toast.current.show({ severity: 'error', summary: 'Error', detail, life: 3000 })

    if (vendorName === '') {
      return showError('Please Enter The Vendor Name')
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(vendorEmail)) {
      return showError('Please Enter a Valid Email Address')
    }
    if (!/^(?:[6-9]\d{9})$/.test(vendorPhone)) {
      return showError('Please Enter a Valid Phone Number')
    }
    if (gstin && /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(gstin) === false) {
      return showError('Please Enter a Valid GSTIN')
    }
    // Address validations
    if (addresses.length === 0) {
      return showError('Please add at least one address')
    }
    for (let i = 0; i < addresses.length; i++) {
      const addr = addresses[i]
      if (!addr.addressNickName.trim()) return showError(`Address ${i + 1}: Please enter a Nick Name`)
      if (!addr.addressLine1.trim()) return showError(`Address ${i + 1}: Please enter Address Line 1`)
      if (!addr.state.trim()) return showError(`Address ${i + 1}: Please enter State`)
      if (!addr.pincode.trim()) return showError(`Address ${i + 1}: Please enter Pincode`)
    }
    // Contact person validations
    if (contactPersons.some(cp => cp.name === '')) {
      return showError('Please Enter Contact Person Name')
    }
    if (contactPersons.some(cp => !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cp.email))) {
      return showError('Please Enter a Valid Contact Person Email')
    }
    if (contactPersons.some(cp => !/^(?:[6-9]\d{9})$/.test(cp.phone))) {
      return showError('Please Enter a Valid Contact Person Phone')
    }
    if (contactPersons.some(cp => cp.designation === '')) {
      return showError('Please Enter Contact Person Designation')
    }

    try {
      const payload = {
        vendorName,
        vendorEmail,
        vendorPhone,
        gstin,
        address: addresses,
        contactPersons,
      }
      const response = await fetch(`${API_URL}vendors`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      })
      const result = await response.json()
      if (result.error === false) {
        setShowSuccessModal(true)
      } else {
        showError(result.message || 'Something went wrong')
      }
    } catch (error) {
      setShowDeclineModal(true)
    }
  }

  return (
    <Fragment>
      <div className='p-4'>
        <Card>
          <CardHeader>Add Vendor</CardHeader>
          <CardBody>
            <div className='p-4'>
              <form className='row g-3 needs-validation' noValidate>

                {/* ── Basic Info ── */}
                <div className='row mt-3 pb-3 border-bottom'>
                  <div className='col-md-4'>
                    <label className='form-label'>
                      Vendor Name <span className='text-danger'>*</span>
                    </label>
                    <input
                      value={vendorName}
                      onChange={e => setVendorName(e.target.value)}
                      type='text'
                      className='form-control'
                      required
                    />
                  </div>

                  <div className='col-md-4'>
                    <label className='form-label'>
                      Vendor Email <span className='text-danger'>*</span>
                    </label>
                    <input
                      value={vendorEmail}
                      onChange={e => setVendorEmail(e.target.value)}
                      type='email'
                      className='form-control'
                      required
                    />
                  </div>

                  <div className='col-md-4'>
                    <label className='form-label'>
                      Phone <span className='text-danger'>*</span>
                    </label>
                    <input
                      value={vendorPhone}
                      onChange={e => setVendorPhone(e.target.value)}
                      type='number'
                      className='form-control'
                      required
                    />
                  </div>

                  <div className='col-md-4 mt-2'>
                    <label className='form-label'>GSTIN</label>
                    <input
                      type='text'
                      className='form-control'
                      value={gstin}
                      onChange={e => setGstin(e.target.value.toUpperCase())}
                    />
                  </div>
                </div>

                {/* ── Addresses ── */}
                {addresses.map((addr, index) => (
                  <div className='row mt-3 pb-3 border-bottom' key={index}>
                    <div className='col-12'>
                      <span className='d-flex justify-content-between align-items-center mb-2'>
                        <h6 className='mb-0'>
                          Address {index + 1}
                        </h6>
                        {addresses.length > 1 && (
                          <Link className='text-dark no-underline'>
                            <FontAwesomeIcon
                              className='ml-1 text-danger'
                              onClick={() => handleDeleteAddress(index)}
                              icon={faTrashCan}
                            />
                          </Link>
                        )}
                      </span>
                    </div>

                    <div className='col-md-4 mt-2'>
                      <label className='form-label'>
                        Nick Name <span className='text-danger'>*</span>
                      </label>
                      <input
                        name='addressNickName'
                        type='text'
                        className='form-control'
                        placeholder='e.g. Head Office, Warehouse'
                        value={addr.addressNickName}
                        onChange={e => handleAddressInput(e, index)}
                      />
                    </div>

                    <div className='col-md-4 mt-2'>
                      <label className='form-label'>
                        Address Line 1 <span className='text-danger'>*</span>
                      </label>
                      <input
                        name='addressLine1'
                        type='text'
                        className='form-control'
                        placeholder='Building / Street'
                        value={addr.addressLine1}
                        onChange={e => handleAddressInput(e, index)}
                      />
                    </div>

                    <div className='col-md-4 mt-2'>
                      <label className='form-label'>Address Line 2</label>
                      <input
                        name='addressLine2'
                        type='text'
                        className='form-control'
                        placeholder='Area / Landmark (optional)'
                        value={addr.addressLine2}
                        onChange={e => handleAddressInput(e, index)}
                      />
                    </div>

                    <div className='col-md-4 mt-2'>
                      <label className='form-label'>
                        State <span className='text-danger'>*</span>
                      </label>
                      <input
                        name='state'
                        type='text'
                        className='form-control'
                        placeholder='e.g. Maharashtra'
                        value={addr.state}
                        onChange={e => handleAddressInput(e, index)}
                      />
                    </div>

                    <div className='col-md-4 mt-2'>
                      <label className='form-label'>Country</label>
                      <input
                        name='country'
                        type='text'
                        className='form-control'
                        value={addr.country}
                        onChange={e => handleAddressInput(e, index)}
                      />
                    </div>

                    <div className='col-md-4 mt-2'>
                      <label className='form-label'>
                        Pincode <span className='text-danger'>*</span>
                      </label>
                      <input
                        name='pincode'
                        type='text'
                        className='form-control'
                        placeholder='e.g. 411057'
                        value={addr.pincode}
                        onChange={e => handleAddressInput(e, index)}
                      />
                    </div>
                  </div>
                ))}

                <div className='row mt-2 pb-3 border-bottom'>
                  <div className='col-md-4'>
                    {addresses.length < 5 && (
                      <button
                        type='button'
                        onClick={handleAddAddress}
                        className='btn add-btn text-white'
                      >
                        + Add Another Address
                      </button>
                    )}
                  </div>
                </div>

                {/* ── Contact Persons ── */}
                {contactPersons.map((person, index) => (
                  <div className='row mt-3' key={index}>
                    <div>
                      <span className='d-flex justify-content-between'>
                        <h6>
                          Add{' '}
                          {(() => {
                            const ordinals = ['First', 'Second', 'Third', 'Fourth', 'Fifth']
                            return (
                              ordinals[(countContactPerson = countContactPerson + 1) - 1] ||
                              countContactPerson
                            )
                          })()}{' '}
                          Contact Person
                        </h6>
                        {countContactPerson > 1 ? (
                          <span>
                            <Link className='text-dark no-underline'>
                              <FontAwesomeIcon
                                className='ml-1 text-danger'
                                onClick={() => handleDeleteContactPerson(index)}
                                icon={faTrashCan}
                              />
                            </Link>
                          </span>
                        ) : (
                          ' '
                        )}
                      </span>
                    </div>

                    <div className='col-md-6'>
                      <label className='form-label'>
                        Name <span className='text-danger'>*</span>
                      </label>
                      <input
                        name='name'
                        type='text'
                        className='form-control'
                        value={person.name}
                        onChange={e => handleContactInput(e, index)}
                      />
                    </div>

                    <div className='col-md-6'>
                      <label className='form-label'>
                        Email <span className='text-danger'>*</span>
                      </label>
                      <input
                        name='email'
                        type='email'
                        className='form-control'
                        value={person.email}
                        onChange={e => handleContactInput(e, index)}
                      />
                    </div>

                    <div className='col-md-4 mt-3'>
                      <label className='form-label'>
                        Phone Number <span className='text-danger'>*</span>
                      </label>
                      <input
                        name='phone'
                        type='number'
                        className='form-control'
                        value={person.phone}
                        onChange={e => handleContactInput(e, index)}
                      />
                    </div>

                    <div className='col-md-4 mt-3'>
                      <label className='form-label'>
                        Designation <span className='text-danger'>*</span>
                      </label>
                      <input
                        name='designation'
                        type='text'
                        className='form-control'
                        value={person.designation}
                        onChange={e => handleContactInput(e, index)}
                      />
                    </div>
                  </div>
                ))}

                <div className='row mt-3'>
                  <div className='col-md-4'>
                    {contactPersons.length < 5 ? (
                      <button
                        type='button'
                        onClick={handleAddContactPerson}
                        className='btn add-btn text-white'
                      >
                        Add New Contact
                      </button>
                    ) : (
                      ' '
                    )}
                  </div>
                </div>

                {/* ── Submit ── */}
                <div className='row mt-3'>
                  <div className='col-md-12'>
                    <button
                      className='btn add-btn text-white'
                      onClick={handleSubmit}
                      type='button'
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>

              <Toast ref={toast} />
            </div>
          </CardBody>
        </Card>
      </div>

      {/* ── Success Modal ── */}
      <Modal show={showSuccessModal} centered>
        <Modal.Body>
          <div className='my-8 text-center'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              className='w-14 shrink-0 fill-green-500 inline'
              viewBox='0 0 512 512'
            >
              <path d='M383.841 171.838c-7.881-8.31-21.02-8.676-29.343-.775L221.987 296.732l-63.204-64.893c-8.005-8.213-21.13-8.393-29.35-.387-8.213 7.998-8.386 21.137-.388 29.35l77.492 79.561a20.687 20.687 0 0 0 14.869 6.275 20.744 20.744 0 0 0 14.288-5.694l147.373-139.762c8.316-7.888 8.668-21.027.774-29.344z' />
              <path d='M256 0C114.84 0 0 114.84 0 256s114.84 256 256 256 256-114.84 256-256S397.16 0 256 0zm0 470.487c-118.265 0-214.487-96.214-214.487-214.487 0-118.265 96.221-214.487 214.487-214.487 118.272 0 214.487 96.221 214.487 214.487 0 118.272-96.215 214.487-214.487 214.487z' />
            </svg>
            <h4 className='text-xl text-gray-800 font-semibold mt-4'>Good Job</h4>
            <p className='text-sm text-gray-500 leading-relaxed mt-4'>
              Vendor Added Successfully!
            </p>
          </div>
          <button
            type='button'
            onClick={handleCloseModal}
            className='px-5 py-2.5 w-full rounded-lg text-white text-sm border-none outline-none bg-green-500 hover:bg-green-700'
          >
            Okay
          </button>
        </Modal.Body>
      </Modal>

      {/* ── Error Modal ── */}
      <Modal show={showDeclineModal} centered>
        <Modal.Body>
          <div className='my-8 text-center'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              className='w-14 fill-red-500 inline'
              viewBox='0 0 286.054 286.054'
            >
              <path
                fill='#e2574c'
                d='M143.027 0C64.04 0 0 64.04 0 143.027c0 78.996 64.04 143.027 143.027 143.027 78.996 0 143.027-64.022 143.027-143.027C286.054 64.04 222.022 0 143.027 0zm0 259.236c-64.183 0-116.209-52.026-116.209-116.209S78.844 26.818 143.027 26.818s116.209 52.026 116.209 116.209-52.026 116.209-116.209 116.209zm.009-196.51c-10.244 0-17.995 5.346-17.995 13.981v79.201c0 8.644 7.75 13.972 17.995 13.972 9.994 0 17.995-5.551 17.995-13.972V76.707c-.001-8.43-8.001-13.981-17.995-13.981zm0 124.997c-9.842 0-17.852 8.01-17.852 17.86 0 9.833 8.01 17.843 17.852 17.843s17.843-8.01 17.843-17.843c-.001-9.851-8.001-17.86-17.843-17.86z'
              />
            </svg>
            <h4 className='text-xl text-gray-800 font-semibold mt-4'>
              Error Occurred
            </h4>
            <p className='text-sm text-gray-500 leading-relaxed mt-4'>
              Something went wrong!
            </p>
          </div>
          <button
            type='button'
            onClick={handleCloseModal}
            className='px-5 py-2.5 w-full rounded-lg text-white text-sm border-none outline-none bg-red-500 hover:bg-red-700'
          >
            Okay
          </button>
        </Modal.Body>
      </Modal>
    </Fragment>
  )
}

export default AddVendor